import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { isNative } from "~/lib/capacitor";
import { openExternal } from "~/lib/external-link";
import { configuredStoreUrl, openNativeInvite } from "~/lib/invite-links";

/** Web landing actions for handing an invitation to an installed mobile app. */
export function InviteInstallActions({ token }: { token: string }) {
  const { t } = useTranslation();
  const fallbackUrl = configuredStoreUrl();
  const cancelRef = useRef<(() => void) | null>(null);

  useEffect(() => () => cancelRef.current?.(), []);

  // The hand-off only belongs on the browser landing page. Inside the installed app
  // it would offer to open the app the member is already using.
  if (isNative()) return null;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      <Button
        type="button"
        variant="outlined"
        size="small"
        onClick={() => {
          cancelRef.current?.();
          cancelRef.current = openNativeInvite(token, fallbackUrl);
        }}
        data-testid="invite.open-app"
      >
        {t("invite.openApp")}
      </Button>
      {fallbackUrl ? (
        <Button
          type="button"
          variant="text"
          size="small"
          onClick={() => void openExternal(fallbackUrl)}
          data-testid="invite.open-store"
        >
          {t("invite.openStore")}
        </Button>
      ) : null}
    </Box>
  );
}
